import React, { FC, useState } from 'react';
import styles from './Header.module.scss';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import './Header.scss';
import HeaderInfo from './HeaderInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { RootState } from '../../../rootReducer';
import { connect } from 'react-redux';
import MenuDrawer from './MenuDrawer';
import { whereToNavigate } from '../Landing/Helpers';
import useAuth from '../../../Auth/UseAuth';
import { isStringNullOrEmpty } from '../../AnnotationManager/Annotation/AnnotationForm/Utils';

type HeaderProps = {
  fullScreenMode: boolean;
};

const Header: FC<RouteComponentProps & HeaderProps> = ({ history, location, fullScreenMode }) => {
  const [showSideMenu, setShowSideMenu] = useState(false);

  const { logoUrl } = useAuth();

  const goToHome = () => {
    const { home } = whereToNavigate(location);
    history.push(home);
  };

  return (
    <div className={styles.headerContainer} style={{ display: fullScreenMode ? 'none' : '' }}>
      <div>
        <span className='button-container'>
          <FontAwesomeIcon icon={faBars} className='bars-button' onClick={() => setShowSideMenu(!showSideMenu)} size='lg' />
        </span>
        <div className='side-menu-container'>
          <MenuDrawer showMenu={showSideMenu} hideMenu={() => setShowSideMenu(false)}></MenuDrawer>
        </div>
      </div>

      <div className={styles.headerLogoContainer} onClick={goToHome}>
        {!isStringNullOrEmpty(logoUrl) && (
          <div>
            <img src={logoUrl} alt='logo' />
          </div>
        )}
      </div>
      <div className={styles.clippedPart} />
      <div className={styles.headerInfoContainer}>
        <HeaderInfo />
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  fullScreenMode: state.annotation.fullScreenMode
});

export default connect(mapStateToProps)(withRouter(Header));
